import { trackButtonClick, trackTabShown } from '../../../lib/fpti';
import clientLogger from '../../../lib/logger';

export const getAddressSummary = ({
  address: { addressLine1, addressLine2, adminArea2, adminArea1, postalCode, countryCode } = {},
  name: { firstName, lastName, fullName } = {},
  phoneNumber: { countryCode: telCountryCode, nationalNumber } = {}
}) => {
  const isNotEmpty = (field) => !!field;
  const summary = [
    fullName || [firstName, lastName].filter(isNotEmpty).join(' '),
    [addressLine1, addressLine2].filter(isNotEmpty).join(', '),
    [adminArea2, [adminArea1, postalCode].filter(isNotEmpty).join(' '), countryCode]
      .filter(isNotEmpty)
      .join(', '),
    [telCountryCode, nationalNumber].filter(isNotEmpty).join('')
  ];
  return summary.filter(isNotEmpty).join('\n');
};

export const emailSubmit = async (email, identity) => {
  if (!email) return {};
  const { customerContextId } = await identity.lookupCustomerByEmail(email);

  if (customerContextId) {
    const authResponse = await identity.triggerAuthenticationFlow(customerContextId);
    if (authResponse?.authenticationState === 'succeeded') {
      trackTabShown('Fastlane Authentication Success');
      const profilePaymentToken = authResponse.profileData.card;
      const profileShippingAddress = authResponse.profileData.shippingAddress;
      return {
        profileAuthState: 'succeeded',
        profilePaymentToken,
        profileShippingAddress
      };
    }
    clientLogger.cal.info('Email Submit. Customer context but not successful auth.');
    return {};
  }
  clientLogger.cal.info('Email Submit. No customer context.');
  return {};
};

export const changeAddress = async (profile, paymentComponent, setShippingAddress) => {
  const { selectionChanged, selectedAddress } = await profile.showShippingAddressSelector();

  if (selectionChanged) {
    // selectedAddress contains the new address
    if (paymentComponent) paymentComponent.setShippingAddress(selectedAddress);
    setShippingAddress(selectedAddress);
    trackButtonClick('Address Changed');
  } else {
    // selection modal was dismissed without selection
  }
};

export const changePayment = async (profile, setPaymentToken) => {
  const { selectionChanged, selectedCard } = await profile.showCardSelector();
  if (selectionChanged) {
    setPaymentToken(selectedCard);
    trackButtonClick('Payment Changed');
  } else {
    // selection modal was dismissed without selection
  }
};

export const removeAllChildren = (element) => {
  // Get the DOM element
  const domElement = document.getElementById(element);

  // Remove all children
  while (domElement?.firstChild) {
    domElement.removeChild(domElement.firstChild);
  }
};

export const modalStyleOverrideTempHack = () => {
  // set modal styling as a temp workaround
  setTimeout(() => {
    try {
      const watermarkComponent = document.querySelector('#watermark-container > paypal-watermark');
      const watermarkOverlayBackground = watermarkComponent.shadowRoot
        .querySelector('div > axo-tooltip')
        .shadowRoot.querySelector('axo-modal-sheet')
        .shadowRoot.querySelector('div.bg-black');
      Object.assign(watermarkOverlayBackground.style, {
        'margin-top': '250px'
      });
      const watermarkModalElement = watermarkComponent.shadowRoot
        .querySelector('div > axo-tooltip')
        .shadowRoot.querySelector('axo-modal-sheet')
        .shadowRoot.querySelector('div.bg-axowhite');
      Object.assign(watermarkModalElement.style, {
        'margin-top': '250px'
      });
    } catch {
      // ignore
    }
  }, 300);
};

export const paymentComponentModalTempHack = () => {
  setTimeout(() => {
    try {
      const paymentComponent = document
        .querySelector('#payment-component > paypal-payment')
        .shadowRoot?.querySelector('div > div > paypal-card-selector');
      if (!paymentComponent) return;
      const cardFieldOverlayBackground = paymentComponent.shadowRoot
        .querySelector('axo-view-navigator')
        .shadowRoot.querySelector('axo-modal-sheet')
        .shadowRoot.querySelector('div.bg-black');
      Object.assign(cardFieldOverlayBackground.style, {
        'margin-top': '250px'
      });

      const cardfieldModalElement = paymentComponent.shadowRoot
        .querySelector('axo-view-navigator')
        .shadowRoot.querySelector('axo-modal-sheet')
        .shadowRoot.querySelector('div.bg-axowhite');
      Object.assign(cardfieldModalElement.style, {
        'margin-top': '250px'
      });
    } catch {
      // ignore
    }
  }, 300);
};
